import offersJson from "../../data/tiktokOffers.json";

export default function Section3() {
  const offersData = offersJson;
  return (
    <div className="Section3 py-[35px]">
      <div className="section3-container w-full md:px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[1170px]">
        <h2 className="text-[24px] md:text-[34px] font-bold text-center leading-[40px] mb-[0.67em]">
          What Tiktok Offers!
        </h2>

        <div className="md:flex md:justify-center">
          {offersData.map(({ imgUrl, title, text }, index) => {
            return (
              <div key={title + index} className="md:w-1/3 gap-y-[15px] text-center mb-[40px] md:mb-0">
                <div className="img-cont mb-[10px]">
                  <img className="mx-auto md:mx-0" src={imgUrl}></img>
                </div>

                <h3 className="mb-[5px] mt-[0.67em] text-[#da2128] text-[20px] md:text-[19px] lg:text-[22px] font-bold leading-[40px] md:leading-[1.1] lg:leading-[40px]">{title}</h3>

                <p className="mb-[20px] text-[#373737] text-[14px] font-open">{text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
